function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 300,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 275,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 250,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 225,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 200,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 175,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 150,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 125,
  stroke: "#114FEE",
  strokeWidth: 10
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 100,
  stroke: "#1D83F9",
  strokeWidth: 10
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 75,
  stroke: "#1D83F9",
  strokeWidth: 10
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 50,
  stroke: "#1D83F9",
  strokeWidth: 10
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 305,
  cy: 294,
  r: 25,
  stroke: "#1D83F9",
  strokeWidth: 10
});

function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 500,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDI0IiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAwIDQyNCA1MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjMwMCIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjI3NSIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjI1MCIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjIyNSIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjIwMCIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjE3NSIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjE1MCIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjEyNSIgc3Ryb2tlPSIjMTE0RkVFIiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9IjEwMCIgc3Ryb2tlPSIjMUQ4M0Y5IiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8Y2lyY2xlIGN4PSIzMDUiIGN5PSIyOTQiIHI9Ijc1IiBzdHJva2U9IiMxRDgzRjkiIHN0cm9rZS13aWR0aD0iMTAiLz4NCjxjaXJjbGUgY3g9IjMwNSIgY3k9IjI5NCIgcj0iNTAiIHN0cm9rZT0iIzFEODNGOSIgc3Ryb2tlLXdpZHRoPSIxMCIvPg0KPGNpcmNsZSBjeD0iMzA1IiBjeT0iMjk0IiByPSIyNSIgc3Ryb2tlPSIjMUQ4M0Y5IiBzdHJva2Utd2lkdGg9IjEwIi8+DQo8L3N2Zz4NCg==";
export { SvgCircle as ReactComponent };